/**
 *
 * @module purchaseActivation
 *
 */

import Check from 'check-types';
import Exception from './../exception/entry';
import InvalidArgumentException from './../exception/invalidArgumentException';
import PurchaseActivationStatus from './purchaseActivationStatus';

const ErrorReason = Exception.ErrorReason;

const {
    array,
    assigned,
    instanceStrict,
    nonEmptyString
} = Check.assert;

/**
 *
 * @class PurchaseActivation
 * @since 3.5.0
 * @desc The information about the purchase activation.
 *
 */
export default class PurchaseActivation {

    /**
     *
     * @param {Array<String>} [products=[]]
     * @param {String} [sku='']
     * @param {PurchaseActivationStatus} status
     * @param {ErrorReason} [reason=null]
     * @note Normally optional params would be at the end but in this case they
     * are in this order to match the service response.
     *
     */
    constructor(products = [], sku = '', status, reason = null) {

        const errorMessage = {
            method: 'purchaseActivation(products, sku, status, reason)',
            get products() {
                return `${this.method} products should be an Array`;
            },
            get sku() {
                return `${this.method} sku should be a string with length`;
            },
            get status() {
                return `${this.method} needs PurchaseActivationStatus instance`;
            },
            get reason() {
                return `${this.method} needs ErrorReason instance`;
            }
        };

        array(products, errorMessage.products, InvalidArgumentException);
        nonEmptyString(sku, errorMessage.sku, InvalidArgumentException);
        assigned(PurchaseActivationStatus[status], errorMessage.status, InvalidArgumentException);

        if (Check.assigned(reason)) {
            instanceStrict(reason, ErrorReason, errorMessage.reason, InvalidArgumentException);
        }

        /**
         *
         * @access private
         * @type {Array<String>}
         * @desc The product ids, as given by the subscription service.
         *
         */
        this.products = products;

        /**
         *
         * @access private
         * @type {String}
         * @desc The SKU, as given by the 3rd party store.
         *
         */
        this.sku = sku;

        /**
         *
         * @access private
         * @type {PurchaseActivationStatus}
         * @desc The status of the purchase. One of ["ACTIVE", "EXPIRED", "FAILED", "IGNORED", "UNKNOWN"].
         * This is tightly coupled with the reason field.
         *
         */
        this.status = status;

        /**
         *
         * @access private
         * @type {SDK.Services.Exception.ErrorReason}
         * @desc The reason that the purchase was ignored or the subscription may not be in effect.
         * This is tightly coupled with the status field.
         *
         */
        this.reason = reason;

    }

}



// WEBPACK FOOTER //
// ./src/services/purchase/purchaseActivation.js